import React, { useState, useEffect } from 'react';
import { Clock, Filter } from 'lucide-react';
import api from '../api';

const ACTION_LABELS = {
  seed_database: 'Generación de datos',
  file_upload: 'Carga de archivo',
  file_process: 'Procesamiento de archivo',
  homologation_approve: 'Homologación aprobada',
  product_update: 'Actualización de producto',
  product_create: 'Creación de producto',
  order_adjust: 'Ajuste de pedido',
  order_confirm: 'Confirmación de pedido',
  ai_homologation: 'IA - Homologación',
  ai_executive_summary: 'IA - Resumen ejecutivo',
  user_register: 'Registro de usuario',
};

export default function History() {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [actionFilter, setActionFilter] = useState('');
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (actionFilter) params.set('action', actionFilter);
      params.set('page', page);
      params.set('limit', 30);
      const result = await api.audit(params.toString());
      setLogs(result.logs || []);
      setTotal(result.total || 0);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  useEffect(() => { load(); }, [page, actionFilter]);

  return (
    <div>
      <div className="data-table-container" data-testid="history-log-table">
        <div className="data-table-header">
          <h3>{total} eventos registrados</h3>
          <div className="data-table-actions">
            <select className="filter-select" data-testid="history-filter-button" value={actionFilter} onChange={e => { setActionFilter(e.target.value); setPage(1); }}>
              <option value="">Todas las acciones</option>
              {Object.entries(ACTION_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>
        </div>

        {loading ? (
          <div className="loading-spinner"><div className="spinner" /></div>
        ) : logs.length === 0 ? (
          <div className="empty-state"><Clock size={48} /><h3>Sin eventos registrados</h3><p>Las operaciones del sistema se registrarán aquí.</p></div>
        ) : (
          <>
            <table className="data-table">
              <thead>
                <tr>
                  <th>Fecha y hora</th>
                  <th>Acción</th>
                  <th>Usuario</th>
                  <th>Detalles</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log, i) => (
                  <tr key={log._id || i}>
                    <td className="mono" style={{fontSize:'0.75rem',whiteSpace:'nowrap'}}>
                      {log.timestamp ? new Date(log.timestamp).toLocaleString('es-MX') : '-'}
                    </td>
                    <td>
                      <span className={`status-badge ${log.action?.includes('ai') ? 'info' : log.action?.includes('error') ? 'critical' : 'ok'}`}>
                        <span className="dot" />
                        {ACTION_LABELS[log.action] || log.action}
                      </span>
                    </td>
                    <td style={{fontSize:'0.78rem'}}>{log.user || 'system'}</td>
                    <td style={{fontSize:'0.72rem',color:'hsl(var(--muted-foreground))',maxWidth:'300px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                      {JSON.stringify(log.details || {}).substring(0, 120)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="pagination">
              <button disabled={page <= 1} onClick={() => setPage(p => p - 1)}>&lt;</button>
              <span style={{fontSize:'0.78rem',padding:'0 8px'}}>Página {page} de {Math.ceil(total / 30) || 1}</span>
              <button disabled={page >= Math.ceil(total / 30)} onClick={() => setPage(p => p + 1)}>&gt;</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
